<template>
  <nav
    id="site-navigation"
    class="has-branding main-navigation nav-align-right sub-menu-right"
    aria-label="Primary">
    <div class="inside-navigation">
      <div class="navigation-branding">
        <div class="site-logo">
          <a href="/" title="WhatsApp Aero" rel="home">
            <img
              class="header-image is-logo-image"
              alt="WhatsApp Aero"
              :src="brandLogo"
              title="WhatsApp Aero"
              width="48"
              height="48">
          </a>
        </div>
        <p class="main-title">
          <a href="/" rel="home">WhatsApp Aero</a>
        </p>
      </div>

      <ul
        v-show="isMenuClicked"
        id="menu-primary-menu-mobile"
        class="menu sf-menu mobile-menu-page">
        <li class="menu-item">
          <a href="/">Home</a>
        </li>
        <li class="menu-item">
          <a href="/features/">Features</a>
        </li>
        <li class="menu-item">
          <a href="/install-whatsapp-aero-apk/">Install</a>
        </li>
        <li class="menu-item">
          <a href="/update-whatsapp-aero/">Update</a>
        </li>
        <li class="menu-item">
          <a href="/how-to-stay-safe/">Anti-Ban</a>
        </li>
        <li class="menu-item header-download">
          <a href="/download/" class="download-btn">Download</a>
        </li>
        <li v-if="isBlogsPage" class="menu-item">
          <a href="/blog/" @click="closeMobileMenu">Blog</a>
        </li>
        <li v-else class="menu-item menu-item-has-children blog-dropdown" :class="{ 'is-open': isBlogOpen }">
          <a href="/blog/" @click="toggleBlogMenu">Blog</a>
          <ul v-show="isBlogOpen" class="sub-menu">
            <li v-for="item in blogItems" :key="item.url" class="menu-item">
              <a :href="item.url" @click="closeMobileMenu">{{ item.navTitle || item.title }}</a>
            </li>
          </ul>
        </li>
      </ul>

      <div id="primary-menu" class="main-nav">
        <div v-if="$global.isMobileDevice()" class="mobile-menu">
          <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
            <img v-if="!isMenuClicked" src="@/assets/menu.svg" alt="menu button">
            <img v-else src="@/assets/xmark-black.svg" alt="close button">
          </div>
        </div>
        <ul v-else id="menu-primary-menu" class="menu sf-menu">
          <li class="menu-item">
            <a href="/">Home</a>
          </li>
          <li class="menu-item">
            <a href="/features/">Features</a>
          </li>
          <li class="menu-item">
            <a href="/install-whatsapp-aero-apk/">Install</a>
          </li>
          <li class="menu-item">
            <a href="/update-whatsapp-aero/">Update</a>
          </li>
          <li class="menu-item">
            <a href="/how-to-stay-safe/">Anti-Ban</a>
          </li>
          <li class="menu-item header-download">
            <a href="/download/" class="download-btn">Download</a>
          </li>
          <li v-if="isBlogsPage" class="menu-item">
            <a href="/blog/">Blog</a>
          </li>
          <li v-else class="menu-item menu-item-has-children blog-dropdown">
            <a href="/blog/">Blog</a>
            <ul class="sub-menu">
              <li v-for="item in blogItems" :key="item.url" class="menu-item">
                <a :href="item.url">{{ item.navTitle || item.title }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { brandLogo } from '@/config/brandAssets';
import blogs from '@/documents/blogs.js';

export default {
  props: {
    selectedLanguage: { type: String, required: true },
    page: { type: String, required: true },
    gotodownload: { type: Function },
    apk: { type: Object },
  },
  data() {
    return {
      brandLogo,
      isMenuClicked: false,
      isBlogOpen: false,
    };
  },
  computed: {
    blogItems() {
      return blogs.bloglist[this.selectedLanguage] || blogs.bloglist.en || [];
    },
    isBlogsPage() {
      return this.page === 'blogs';
    },
  },
  methods: {
    toggleBlogMenu(e) {
      if (this.$global.isMobileDevice()) {
        e.preventDefault();
        this.isBlogOpen = !this.isBlogOpen;
      }
    },
    closeMobileMenu() {
      this.isMenuClicked = false;
      this.isBlogOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#site-navigation {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 24px rgba(53, 84, 143, 0.07);

  .inside-navigation {
    width: min(1080px, 94%);
    margin: 0 auto;
    z-index: 9999;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 64px;
  }
}

.navigation-branding {
  display: flex;
  align-items: center;
  gap: 12px;

  .header-image {
    width: 48px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 6px 14px rgba(53, 84, 143, 0.12);
  }

  .main-title {
    margin: 0;
    line-height: 1.2;

    a {
      font-size: 1.25rem;
      font-weight: 700;
      color: #35548f;
      text-decoration: none;
    }
  }
}

.main-nav .menu {
  list-style: none !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  gap: 4px;

  li a {
    font-weight: 600 !important;
    font-size: 15px;
    border-radius: 4px;
    transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

    &:hover {
      background: #f4f7fb;
      transform: translateY(-1px);
    }
  }
}

// Blog 下拉菜单
.blog-dropdown {
  position: relative;

  > a::after {
    content: '';
    display: inline-block;
    margin-left: 6px;
    border: 4px solid transparent;
    border-top-color: currentColor;
    transform: translateY(-2px);
  }

  .sub-menu {
    display: none;
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    min-width: 190px;
    max-width: 240px;
    margin: 0 !important;
    padding: 8px 0;
    list-style: none !important;
    background: #fff;
    border: 1px solid #dce3ec;
    border-radius: 8px;
    box-shadow: 0 16px 34px rgba(53, 84, 143, 0.14);
    z-index: 1002;

    .menu-item {
      margin: 0 !important;
      padding: 0;
      list-style: none !important;
      border-bottom: none;
    }

    a {
      display: block;
      padding: 10px 16px;
      font-size: 14px !important;
      line-height: 1.45;
      color: #35548f !important;
      font-weight: 600 !important;
      white-space: normal;
      text-align: left;

      &:hover {
        background: #f4f7fb;
        color: #35548f !important;
      }
    }
  }

  &:hover .sub-menu {
    display: block;
  }
}

@media screen and (max-width: 768px) {
  .inside-navigation .mobile-menu-page {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1001;
    margin: 0 !important;
    border: 1px solid #d4d4d4;
    border-top: none;
    background: #fff;

    .menu-item {
      padding: 14px 0;
      margin-bottom: 0 !important;
      border-bottom: 1px solid #eee;

      a {
        font-size: 15px;
        text-align: center;
        color: #555;
        display: block;
      }
    }

    .header-download a {
      color: #fff !important;
    }

    .blog-dropdown {
      padding: 0;

      > a {
        padding: 14px 0;
      }

      .sub-menu {
        display: none;
        position: static;
        min-width: 0;
        max-width: none;
        margin: 0 !important;
        padding: 0;
        border: none;
        border-radius: 0;
        box-shadow: none;
        background: #f8fafc;
        border-top: 1px solid #eee;

        a {
          padding: 12px 20px;
          font-size: 14px !important;
          text-align: left;
          border-bottom: 1px solid #eef1f5;
        }

        li:last-child a {
          border-bottom: none;
        }
      }

      &.is-open .sub-menu {
        display: block;
      }

      &:hover .sub-menu {
        display: none;
      }

      &.is-open:hover .sub-menu {
        display: block;
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;

      .menu-toggle {
        display: flex;
        justify-content: center;
        padding: 12px;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
